import { useMutation } from "@tanstack/react-query";
import i18n from "i18n";
import { ClusterHealthAlerts } from "@graylog/enterprise-api";
import UserNotification from "util/UserNotification";
const createHealthAlert = (request) => ClusterHealthAlerts.create(
  request
);
const useCreateHealthAlert = () => {
  const mutation = useMutation({
    mutationFn: createHealthAlert,
    onError: (errorThrown) => {
      var _a, _b;
      if (errorThrown.status !== 400 || !((_b = (_a = errorThrown.additional) == null ? void 0 : _a.body) == null ? void 0 : _b.failed)) {
        UserNotification.error(
          i18n.t("health.alert.create_failed", { ns: "enterprise_license", error: errorThrown }),
          i18n.t("health.alert.create_failed_title", { ns: "enterprise_license" })
        );
      }
    },
    onSuccess: (eventDefinition) => {
      UserNotification.success(
        i18n.t("health.alert.create_success", { ns: "enterprise_license" }),
        i18n.t("health.alert.create_success_message", { ns: "enterprise_license", title: eventDefinition.title })
      );
    }
  });
  return { createHealthAlert: mutation.mutateAsync, isCreating: mutation.isPending };
};
export default useCreateHealthAlert;
